import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import IApiVersion from '@/interfaces/IApiVersion';
import { Footer as AppFooter } from '@coreui/vue';

const versionBuildFront = process.env.VUE_APP_VERSION_BUILD;
@Component({
    name: 'Footer',
    components: {
        AppFooter
    },
})
export default class Footer extends Vue {
    @Action private getApiVersion!: () => IApiVersion;

    private apiVersion: IApiVersion | null = null;

    get frontedVersion() {
        const versionFront: string | null = versionBuildFront ? versionBuildFront.replace('-production', '') : null;
        return versionFront ? `Front Version: ${versionFront}` : ''
    }

    get backendVersion() {
        return this.apiVersion ? `Api Version: ${this.apiVersion.version} ` : ''
    }

    get buildInfo() {
        const divider = this.apiVersion && versionBuildFront ? ' / ' : '';
        return `${this.backendVersion}${divider}${this.frontedVersion}`
    }

    get footerText() {
        return 'Switcherry &copy; ' + (new Date()).getFullYear();
    }

    async mounted() {
        this.apiVersion = await this.getApiVersion();
    }

}